module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/staff-akabane-d43f92378380be3e5a86bcb9b274377d.webp";